export const DEFAULT_USER_ERROR_MESSAGE = 'There was an error, please retry';

export const getUserErrorMessageFromResponse = (responseError, customErrorMessage = DEFAULT_USER_ERROR_MESSAGE) =>
	responseError?.error?.message || responseError?.message || customErrorMessage;
